module.exports = __webpack_public_path__ + "media/images/flags/ni-ef0b194fefa52dfa07ef5320ae142208.svg";